import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { IAlerts } from '@/modules/explore/interfaces/Alerts';

export const useAlertsStore = defineStore('alerts', () => {
    const alerts = ref<IAlerts[]>([]);

    return {
        alerts,

        setAlerts(newAlerts: IAlerts[]) {
            alerts.value = [...newAlerts];
        }
    };
});
